module.exports = __webpack_public_path__ + "static/media/thumb.b258b87c.jpg";